export function sortFilesWithPinned<T extends { path: string }>(files: T[], pinnedSuffix?: string): T[] {
    if (!pinnedSuffix) return files;
    const pinned = files.filter((f) => f.path.endsWith(pinnedSuffix));
    const rest = files.filter((f) => !f.path.endsWith(pinnedSuffix));
    return [...pinned, ...rest];
}
